import { Alert, Button, Card, Form, Input, InputNumber, Select } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AdGroupBean, AdvertiserBean, RetargetingListBean, SiteVisitRuleBean } from 'src/api/api'
import retargetingListApi from 'src/component/app/retargetingList/RetargetingListApi'
import { formDataLoader, FormDataType } from 'src/util/FormDataLoader'
import { toSort } from 'src/util/useSorter'
import adGroupApi from '../adGroup/AdGroupApi'
import { enumView } from 'src/util/Util'
import SiteVisitRules, { emptySiteVisitRule } from '../siteVisitRule/SiteVisitRules'

const FormItem = Form.Item
const Option = Select.Option

const formInfoItems: FormDataType[] = [
    FormDataType.Advertisers
]

const RetargetingListCreate = () => {

    const [info, setInfo] = useState({
        advertisers: []
    })

    const [availableAdGroups, setAvailableAdGroups] = useState([])

    const [rules, setRules] = useState<SiteVisitRuleBean[]>([emptySiteVisitRule()])

    const [error, setError] = useState(undefined)
    const [form] = Form.useForm()

    const navigateTo = useNavigate()

    const retargetingType = Form.useWatch('retargetingType', form)
    const bySiteVisit = retargetingType == RetargetingListBean.RetargetingTypeEnum.BySiteVisit

    const loadData = async () => {
        try {
            const resp = await formDataLoader(...formInfoItems)
            setInfo(resp as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await retargetingListApi.create({ ...values, rules: bySiteVisit ? rules : undefined })
            navigateTo('/retargeting-list')
        } catch (e) {
            setError(e.error)
        }
    }

    const loadAvailableAdGroups = async () => {
        const adGroupData: any = await adGroupApi.allByAdvertiser(advertiserId, toSort({ sort: 'id', direction: 'asc' }))
        const list = adGroupData.data.map(item => item.data as AdGroupBean)
        setAvailableAdGroups(list)
    }

    const advertiserId = Form.useWatch('advertiserId', form)

    useEffect(() => {
        if (advertiserId) {
            loadAvailableAdGroups()

            form.setFieldValue('adGroupIds', [])
        }
    }, [advertiserId])

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 16 }}
    >
        {error && <Alert message={error} type="error" />}
        <Card title="Retargeting List" size="small" className="form-card">
            <FormItem
                required
                name="name"
                label="Name"
                rules={[{ required: true, message: 'Retargeting List name required' }]}
            >
                <Input placeholder="Name" />
            </FormItem>
            <FormItem
                required
                name="retargetingType"
                label="Retargeting by"
                rules={[{ required: true, message: 'Retargeting List retargeting type required' }]}
            >
                <Select placeholder="Select Retargeting by">
                    {Object.values(RetargetingListBean.RetargetingTypeEnum).map(type => <Option key={type} value={type}>{enumView(type)}</Option>)}
                </Select>
            </FormItem>
            {!bySiteVisit && <FormItem
                name="advertiserId"
                label="Advertiser"
            >
                <Select showSearch optionFilterProp="title" placeholder="Select Advertiser">
                    {info.advertisers.map((item: AdvertiserBean) => <Option title={item.name} key={item.id} value={item.id}>{item.name}</Option>)}
                </Select>
            </FormItem>}
            {!bySiteVisit && <FormItem
                name="adGroupIds"
                label="Ad Groups for Retargeting"
            >
                <Select
                    showSearch
                    allowClear
                    mode="multiple"
                    optionFilterProp="title"
                    placeholder="Select Ad Groups for Retargeting"
                >
                    {availableAdGroups.map((item: AdGroupBean) => <Option title={item.name} key={item.id} value={item.id as number}>{item.name}</Option>)}
                </Select>
            </FormItem>}
            {bySiteVisit && <FormItem
                name="timePeriod"
                className="form-date-item"
                label="Lookback Window"
            >
                <InputNumber min={1} placeholder="Lookback window in days" />
            </FormItem>}
            {bySiteVisit && <FormItem
                name="minSessions"
                className="form-date-item"
                label="Min Sessions"
            >
                <InputNumber min={1} placeholder="Minimum number of sessions" />
            </FormItem>}
            {bySiteVisit && <SiteVisitRules rules={rules} setRules={setRules} />}
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Create</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/retargeting-list')}>Cancel</Button>
        </div>
    </Form>
}

export default RetargetingListCreate



// WEBPACK FOOTER //
// ./src/component/app/retargetingList/RetargetingListCreate.tsx